<template>
    <div class="documentation-section">
        <div class="filter-section sub-filter d-inline-flex mr-2">
            <h2>Documents Submitted </h2>
        </div>
        <!--<base-action v-if="customerDetails.type!='company' && documentExists()"-->
                <!--icon="icon-plus"-->
                <!--title="Upload documents"-->
                <!--@click="openPopup('uploadDocuments')"-->
        <!--&gt;</base-action>-->
        <div class="card document-section">
            <div v-if="showDocTempDetails()">
            <div
            v-if="alertRecord.documentSubmission && alertRecord.documentSubmission == 'pending'"
            :class="'mb-3'"
            >
            <base-status
                        :statusType="'pending'"
                        ></base-status>waiting for the customer to submit latest documents 
           </div>
            <ul class="row">
                <li
                    v-for="(item, index) in customerDetails.tempDocumentInfo"
                    :key="index"
                    :class="item.fileName ? 'col-md-3 mb-3' : ''"
                    v-if="item.fileName && item.fileName!='no-preview.png' && item.fileName!='customers/no-preview.png'
                            && alertRecord.documentSubmission &&alertRecord.documentSubmission == 'submitted'"
                >
                    <base-grid-status
                        :statusType="'pending'"
                        :class="'mb-3'"
                        ></base-grid-status>    
                <div
                        class="document-detail"
                    >
                   
                        <div class="photo-section"  @click="openPopup(index,item)">
                            <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail && item.fileName.split('.').pop() === 'pdf'"
                                    v-authenticated-image="'customer-documents/pdf_icon.png'"
                                />
                                <img
                                    v-else-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                        </div>
                        <div class="upload-detail">
                            <div class="upload-thumbnail">
                                <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail && item.fileName.split('.').pop() === 'pdf'"
                                    v-authenticated-image="'customer-documents/pdf_icon.png'"
                                />
                                <img
                                    v-else-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                              
                            </div>
                            <div class="upload-des">
                                <label>{{ showLabel(index,true) }}</label>
                                <i style="padding: 10px" title="Download file" @click="downloadFile(item.fileName,index)" class="icon-export"></i>

                                <p>
                                    Uploaded
                                    {{
                                        item.uploadedAt | moment('MMM D, YYYY')
                                    }}
                            
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
                
                <div 
            v-if="hasScopes('kyc-status-review') && isVisible()&&alertRecord.documentSubmission && alertRecord.documentSubmission == 'submitted'"
            class="mb-5 mt-3 col-md-12 action-buttons">
            <!-- <b-form @submit.stop.prevent="onSubmitDocument()" @reset="commentBoxPopup()"> -->
                <div class="col-md-12 action-buttons">
                    <b-button
                        type="submit"
                        variant="primary"
                        :btn-disabled ="isTempDocBtnDisabled()"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading || isTempDocBtnDisabled()"
                        @click=" openConfirmationPopup()"
                    >
                       APPROVE
                    </b-button>
                    <b-button
                        type="button"
                        variant="secondary"
                        class="ml-3 primary-add-btn"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading || isTempDocBtnDisabled()"
                        @click="commentBoxPopup()"
                    >
                       REJECT
                    </b-button>
                    
                </div>
            <!-- </b-form> -->
                </div>
            </ul>
            <hr
            v-if="alertRecord.documentSubmission && alertRecord.documentSubmission=='submitted'">
            </div>
            <ul class="row">
                <li
                    v-for="(item, index) in customerDetails.documentInfo"
                    :key="index"
                    :class="item.fileName ? 'col-md-3 mb-3' : ''"
                    v-if="item.fileName && item.fileName!='no-preview.png' && item.fileName!='customers/no-preview.png'"
                >
                    <div
                        class="document-detail"
                    >
                        <div class="photo-section"  @click="openPopup(index,item)">
                            <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail && item.fileName.split('.').pop() === 'pdf'"
                                    v-authenticated-image="'customer-documents/pdf_icon.png'"
                                />
                                <img
                                    v-else-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                        </div>
                        <div class="upload-detail">
                            <div class="upload-thumbnail">
                                <img
                                    v-if="!!item.thumbNail"
                                    v-authenticated-image="item.thumbNail"
                                />
                                <img
                                    v-if="!item.thumbNail && item.fileName.split('.').pop() === 'pdf'"
                                    v-authenticated-image="'customer-documents/pdf_icon.png'"
                                />
                                <img
                                    v-else-if="!item.thumbNail"
                                    v-authenticated-image="item.fileName"
                                />
                              
                            </div>
                            <div class="upload-des">
                                <label>{{ showLabel(index) }}</label>
                                <i style="padding: 10px" title="Download file" @click="downloadFile(item.fileName,index)" class="icon-export"></i>

                                <p>
                                    Uploaded
                                    {{
                                        item.uploadedAt | moment('MMM D, YYYY')
                                    }}
                            
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
                <li
                        v-for="(item, index) in customerDetails.documentInfo.otherDocuments"
                        :key="index"
                        :class="item.fileName ? 'col-md-3 mb-3' : ''"
                >     
                        
                    <div
                            class="document-detail"
                            v-if="item.fileName"
                    >        
                            <div class="photo-section" v-if="item.fileName"
                            @click="otherDocumentsPopup(index)">
                                <!--<pdf v-if="!item.thumbNail" :src="`${fileUrl}customer-documents/${item.fileName}`">-->
                                <!--</pdf>-->
                                <img v-if="item.fileName.split('.').pop() === 'pdf'"
                                        v-authenticated-image="`customer-documents/pdf_icon.png`"
                                />
                                <img v-else-if="item.fileName.split('.').pop() === 'docx'"
                                        v-authenticated-image="`customer-documents/docx_icon.png`"
                                />
                                <!--<img v-if="item.fileName.split('.').pop() === 'png' || item.fileName.split('.').pop() === 'jpg' || item.fileName.split('.').pop() === 'jpeg'"-->
                                     <!--v-authenticated-image="`customer-documents/${item.fileName}`"-->
                                <!--/>-->
                                <img v-else
                                     v-authenticated-image="`customer-documents/${item.fileName}`"
                                />
                            </div>
                        <div class="upload-detail">
                            
                                <div class="upload-thumbnail" v-if="item.fileName">
                                    
                                    <img v-if="item.fileName.split('.').pop() === 'pdf'"
                                         v-authenticated-image="`customer-documents/pdf_icon.png`"
                                    />
                                    <img v-else-if="item.fileName.split('.').pop() === 'docx'"
                                         v-authenticated-image="`customer-documents/docx_icon.png`"
                                    />
                                    <img v-else
                                         v-authenticated-image="`customer-documents/${item.fileName}`"
                                    />
                                </div>
                            <div class="upload-des">
                                <label>{{ item.originalFileName }} </label>

                                    <i style="padding: 10px" title="Download file" @click="downloadFile(item.fileName,index)" class="icon-export"></i>
                                <p>
                                    Uploaded
                                    {{
                                    item.uploadedAt | moment('MMM D, YYYY')
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </li>

            </ul>
        </div>
        <document-preview-popup
            :item="customerDetails.documentInfo.video"
        ></document-preview-popup>
        <picture-preview-popup
                :item="customerDetails.documentInfo.picture"
        ></picture-preview-popup>
        <id-card-preview-popup
            :item="customerDetails.documentInfo.identity"
        ></id-card-preview-popup>
        <id-card-back-preview-popup
            :item="customerDetails.documentInfo.identityBack"
        ></id-card-back-preview-popup>
        <sourceoffunds-document
            v-if="customerDetails.documentInfo.fundsEvidenceDocument"
            :item="customerDetails.documentInfo.fundsEvidenceDocument"
        ></sourceoffunds-document>
        <sourceofwealth-document
            v-if="customerDetails.documentInfo.wealthEvidenceDocument"
            :item="customerDetails.documentInfo.wealthEvidenceDocument"
        ></sourceofwealth-document>
        <bill-preview-popup :item="customerDetails.documentInfo.utility"></bill-preview-popup>
        <visa-page-popup :item="customerDetails.documentInfo.visaPage"></visa-page-popup>
        <emirates-id-popup
            :item="customerDetails.documentInfo.fieldEmiratesID"
        ></emirates-id-popup>
        <emirates-id-back-popup
            :item="customerDetails.documentInfo.fieldEmiratesIDBack"
        ></emirates-id-back-popup>
        <address-proof-popup
            :item="customerDetails.documentInfo.fieldAddressProof"
        ></address-proof-popup>
        <upload-verification-documents-popup
                :customer-details="customerDetails"
        ></upload-verification-documents-popup>
        <license-front-popup
          :item="customerDetails.documentInfo.licenseFront">
        </license-front-popup>
        <license-back-popup
          :item="customerDetails.documentInfo.licenseBack">
        </license-back-popup>
        <ConsentForm-popup
          :item="customerDetails.documentInfo.consentForm">
        </ConsentForm-popup>
        <other-documents-popup
        :item="customerDetails.documentInfo.otherDocuments[this.otherDocsPopup]"
        ></other-documents-popup>
        <document-viewer-popup
                :key="previewDocument ? 'open' : 'closed'"
                :item="previewDocument"
                v-if="previewDocument !== null"
                @reset-preview-document="resetPreviewDocument"
        ></document-viewer-popup>
        <image-viewer-popup
                :key="previewDocument ? 'open' : 'closed'"
                :item="previewDocument"
                v-if="previewDocument !== null"
                @reset-preview-document="resetPreviewDocument"
        ></image-viewer-popup>
        <comment-box
        :options="optionsForCommentBox()"
        @commentSubmit="onResetDocument">  
        </comment-box>
        <confirmation-popup
                :message = "message"
                :type = "type"
                @documentsApproved="onSubmitDocument"
        ></confirmation-popup>
    </div>

</template>

<script>
import uploadVerificationDocumentsPopup from '@/components/popups/UploadVerificationDocuments.vue'
import documentPreviewPopup from '@/components/popups/DocumentPreviewPopup.vue'
import picturePreviewPopup from '@/components/popups/PicturePreviewPopup.vue'
import idCardPreviewPopup from '@/components/popups/IDCardPreviewPopup.vue'
import idCardBackPreviewPopup from '@/components/popups/IDCardBackPreviewPopup.vue'
import billPreviewPopup from '@/components/popups/BillPreviewPopup.vue'
import sourceoffundsDocument from '@/components/popups/SourceoffundsDocument.vue'
import sourceofwealthDocument from '@/components/popups/SourceofwealthDocument.vue'
import visaPagePopup from '@/components/popups/VisaPagePopup.vue'
import emiratesIdPopup from '@/components/popups/EmiratesIdPopup.vue'
import addressProofPopup from '@/components/popups/AddressProofPopup.vue'
import emiratesIdBackPopup from '@/components/popups/EmiratesIdBackPopup.vue'
import LicenseFrontPopup from '@/components/popups/LicenseFrontPopup.vue'
import LicenseBackPopup from '@/components/popups/LicenseBackPopup.vue'
import ConsentFormPopup from '@/components/popups/ConsentFormPopup.vue'
import OtherDocumentsPopup from '@/components/popups/OtherDocumentsPopup.vue'
import DocumentViewerPopup from '@/components/popups/DocumentViewerPopup.vue'
import ImageViewerPopup from '@/components/popups/ImageViewerPopup.vue'
import pdf from 'vue-pdf'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import CommentBox from './CommentBox.vue'
import ConfirmationPopup from '@/components/popups/ConfirmationPopup.vue'
import _ from 'lodash'


export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        documentPreviewPopup,
        picturePreviewPopup,
        idCardPreviewPopup,
        idCardBackPreviewPopup,
        billPreviewPopup,
        sourceoffundsDocument,
        sourceofwealthDocument,
        visaPagePopup,
        emiratesIdPopup,
        addressProofPopup,
        emiratesIdBackPopup,
        uploadVerificationDocumentsPopup,
        LicenseFrontPopup,
        LicenseBackPopup,
        ConsentFormPopup,
        OtherDocumentsPopup,
        DocumentViewerPopup,
        ImageViewerPopup,
        pdf,
        CommentBox,
        ConfirmationPopup
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        customerDetails: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fileUrl:process.env.VUE_APP_FILE_SERVICE_URL,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            otherDocsPopup:0,
            previewDocument : null,
            message: null,
            type: null,
            previousRoute: null
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'profile',
            'hasScopes',
            'dataSegmentId',
            'customerRecord',
            'alertRecord',
            'loading',
            'getField',
            'userId'
        ]),
        documentInfoProp() {
            const obj = JSON.parse(JSON.stringify(this.documentInfo))

            const x = Object.keys(obj)

            x.forEach((key, index) => {
                if (obj[key].fileName === null) {
                    delete obj[key]
                }
            })
            return obj
            //    return this.documentInfo.filter(
            //        i => i.fileName !== null
            //     )
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        console.log('this.documentInfo', this.documentInfo)
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showDocTempDetails(){
            this.previousRoute = localStorage.getItem('goBackUrl')
            if(this.previousRoute == 'view-alerts'){
                return true
            }else{
                return false
            }
        },
        async openConfirmationPopup()
        {
            // this.customerId=customerId
            this.message= `Are you sure you want to Approve? If you want to Reject one or more of the documents,
                           click cancel and then choose the Reject option. In that popup select the documents you 
                           wish to reject, and email will then be sent to the customer asking them to resubmit the document(s).`
            this.type="approveDocuments"
            this.$bvModal.show('confirmation-popup')
        },
        isTempDocBtnDisabled() {
            if (typeof localStorage.getItem('isLeastRole') == 'string') {
                // console.log('role ',localStorage.getItem('isLeastRole'))
                if (localStorage.getItem('isLeastRole') =='false') {
                    return true
                }
            }
            return false
        },
        isVisible(){
            // console.log(this.alertRecord,this.userId,this.alertRecord.updatedById)

            if(this.alertRecord && this.userId==this.alertRecord.updatedById)
            {
                return true
            }
            return false
        },
        optionsForCommentBox(){
          let requiredDocs = []
          if(this.customerDetails.documentTemp && this.customerDetails.documentTemp.requiredDocs){
            requiredDocs = this.customerDetails.documentTemp.requiredDocs
          }
          let documentTemp = this.customerDetails.documentTemp
          let options = {}
        //   console.log("f1")
           for(let i = 0 ; i < requiredDocs.length ; i++ ){
            // console.log("f2",_.get(documentTemp,`documentInfo.fieldEmiratesID.fileName`))
              if( !this.skipOptions(requiredDocs[i]) && 
                  _.get(documentTemp,`${this.documentInfoKey(requiredDocs[i])}.fileName`) 
                ){
                    // console.log("f3")
                         if (this.documentInfoKey(requiredDocs[i]).includes('fieldEmiratesID')){
                             options[requiredDocs[i]] = 'ID Documents'
                         }
                         else{
                            options[requiredDocs[i]] = 'Passport Document'
                         }
                }
           }
           return options
        },
        skipOptions(docKey){
            if(this.tempCountry == 'PK' && docKey == 'identityInfo.passport'){
                return true 
            }
            else if ( this.tempCountry == 'UK' && this.getField("identityInfo.cardType") 
                     && ( this.getField("identityInfo.cardType")!='passport' && docKey =='identityInfo.passport')||
                         (this.getField("identityInfo.cardType") =='passport' && docKey =='identityInfo')){
                return true
            }
            else{
                return false
            }
            
         },
        documentInfoKey(docKey){
            let ListForEmId = ['uaeOldResidentCard','uaeSmartResidentCard','qrp']
            if (ListForEmId.includes(this.customerDetails.documentTemp.identityInfo.cardType) 
                && docKey == 'identityInfo' && this.getField('type')!='company'){
                return "documentInfo.fieldEmiratesID"
            } 
            return "documentInfo.identity"
        },
        commentBoxPopup(){
            this.$bvModal.show('comment-popup')
        },
        async onSubmitDocument(){
            try{
            this.$store.commit('setLoading', true)
            console.log("documents approved")
            const { data } = await request({
                        url: '/customers/save-document-temp-upload-to-customer',
                        method: 'post',
                        data: {"alertId":this.alertRecord._id},
                    })
            if(data){
                this.$store.commit(
                        'setSuccess',
                        'Documents updated successfully'
                    )
                    let customerData = JSON.parse(
                        JSON.stringify(this.customerRecord)
                    )
                    let alert = JSON.parse(JSON.stringify(this.alertRecord))
                    alert.documentSubmission = 'approved'
                    this.$store.commit('setAlertRecord', alert)
                    this.$store.commit('setCustomerRecord', customerData)
                    this.$emit('refresh-documents');
            }
            // this.$store.commit('setSuccess', data.data.message) 
            this.$store.commit('setLoading', false)
            }catch(error){
                console.log("error on approving documents:",error)
                this.$store.commit('setError', "Something went wrong while updating the documents") 
                this.$store.commit('setLoading', false) 
            }
        },
        async onResetDocument(comments){
            try{
            this.$bvModal.hide('comment-popup')
            console.log("comment from commentBox",comments.comments)
            this.$store.commit('setLoading', true)
            const { data } = await request({
                        url: '/customers/reject-document-temp-upload',
                        method: 'post',
                        data: {"alertId":this.alertRecord._id,
                                "modalData":comments},
                    })
            console.log("documents rejected")
            if(data){
                this.$store.commit(
                        'setSuccess',
                        'Email has been sent to customer successfully'
                    )
                    delete this.customerDetails.tempDocumentInfo
                    let customerData = JSON.parse(
                        JSON.stringify(this.customerRecord)
                    )
                    let alert = JSON.parse(JSON.stringify(this.alertRecord))
                    alert.documentSubmission = 'pending'
                    this.$store.commit('setAlertRecord', alert)
                    this.$store.commit('setCustomerRecord', customerData)
            }
            // this.$store.commit('setSuccess', data.data.message) 
            this.$store.commit('setLoading', false) 
        }catch(error){
            console.log("error on rejecting documents:",error)
            this.$store.commit('setError', "Something went wrong while sending email to customer") 
            this.$store.commit('setLoading', false) 
        }
        },
        showLabel(index,isDocTemp = false)
        {   let twoDocCountries = ['UAE','Qatar']
            let notTwoDocsCountries = ['PK','UK']
            let identityInfo= isDocTemp ? this.customerDetails.documentTemp.identityInfo : this.customerDetails.identityInfo
            if(this.customerDetails.type=='company')
            {
                if(index=='identity')
                {
                    if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                    {
                        return "Certificate of Incorporation"
                    }
                    return 'Trade License'
                }
                if(index=='fieldEmiratesID')
                {
                    return 'Memorandum Of Association'
                }
                if(index=='fieldEmiratesIDBack')
                {
                    if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                    {
                        return "Article of Association"
                    }
                    return 'Certificate of Incorporation'
                }
                if(index=='visaPage')
                {
                    if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                    {
                        return "VAT Registration"
                    }
                    return 'Certificate of Incumbency'
                }
                if(index=='fieldAddressProof')
                {
                    if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                    {
                        return "PAY Registration"
                    }
                    return 'Certificate of Good Standing'
                }
                else
                {
                    return index
                }
            }
            else
            {
                if(index=='fieldEmiratesID' || 
                   (index=='identity' && identityInfo.cardType != 'passport' && notTwoDocsCountries.includes(this.tempCountry) ))
                {
                    return 'ID Document Front'
                }
                if(index=='fieldEmiratesIDBack' || 
                   (index=='identityBack' && identityInfo.cardType != 'passport' && notTwoDocsCountries.includes(this.tempCountry) ))
                {
                    return 'ID Document Back'
                }
                else if(index=='identity' && (twoDocCountries.includes(this.tempCountry) ||
                         (this.tempCountry == 'UK' && identityInfo.cardType == 'passport' ))){
                    return 'Passport'
                }
                // if(process.env.VUE_APP_COUNTRY !='Pakistan' && index=='identity')
                // {
                //     return 'Passport'
                // }
                    return index
            }
        },
        documentExists()
        {   console.log('this.customerDetails.documentInfo', this.customerDetails.documentInfo)
            let docs = this.customerDetails.documentInfo
            if (process.env.VUE_APP_COUNTRY === 'Pakistan') {
                if (docs.identity.fileName == null || docs.identityBack.fileName == null || !docs.otherDocuments || (docs.otherDocuments && docs.otherDocuments.length === 0)) {
                    return true
                }
                return false
            }
            else {
                if (docs.identity.fileName == null || docs.fieldEmiratesID.fileName == null || docs.fieldEmiratesID.fileName == null || docs.fieldEmiratesIDBack.fileName == null || docs.visaPage.fileName == null || docs.fieldAddressProof.fileName == null) {
                    return true
                }
                return false
            }
        },
        openPopup(index,item)
        {
          if(index=='video')
          {
              this.$bvModal.show('document-preview-popup')
          }
          else
          {
              let ext = item.fileName? item.fileName.split('.').pop() : null
                  this.previewDocument=item
              console.log('this ise the index--',index,this.previewDocument)
              if(ext=='pdf')
              {
                  this.$bvModal.show('document-viewer-popup')
              }
          else
              {
                  this.$bvModal.show('image-viewer-popup')
              }
          }
        },
        resetPreviewDocument() {
            // Reset the previewDocument in the parent component
            this.previewDocument = null;
            console.log('calling this refresh func')
        },
        openPopupOld(popup) {
            console.log('popup', popup)
            switch (popup) {
                case 'picture':
                    this.$bvModal.show('picture-preview-popup')
                    break
                case 'video':
                    this.$bvModal.show('document-preview-popup')
                    break
                case 'identity':
                    this.$bvModal.show('id-card-preview-popup')
                    break
                case 'identityBack':
                    this.$bvModal.show('id-card-back-preview-popup')
                    break
                case 'utility':
                    this.$bvModal.show('bill-preview-popup')
                    break
                case 'wealthEvidenceDocument':
                    this.$bvModal.show('sourceofwealth-document')
                    break
                case 'fundsEvidenceDocument':
                    this.$bvModal.show('sourceoffunds-document')
                    break
                case 'visaPage':
                    this.$bvModal.show('visa-page-document')
                    break
                case 'fieldEmiratesID':
                    this.$bvModal.show('emirates-id-popup')
                    break
                case 'fieldEmiratesIDBack':
                    this.$bvModal.show('emirates-id-back-popup')
                    break
                case 'fieldAddressProof':
                    this.$bvModal.show('address-proof-popup')
                    break
                case 'uploadDocuments':
                   this.$bvModal.show('upload-verification-documents-popup')
                    break
                case 'licenseFront':
                        this.$bvModal.show('license-front-preview-popup')
                    break
                case 'licenseBack':
                        this.$bvModal.show('license-back-preview-popup')
                    break
                case 'consentForm':
                        this.$bvModal.show('consent-form-preview-popup')
                    break

            }
        },
        otherDocumentsPopup(popup){
            console.log('popup', popup)
            if(
               this.customerDetails.documentInfo.otherDocuments &&
               this.customerDetails.documentInfo.otherDocuments[popup] &&
               this.customerDetails.documentInfo.otherDocuments[popup].fileName &&
               this.customerDetails.documentInfo.otherDocuments[popup].fileName.split('.').pop() !=='docx'
               ){
                this.otherDocsPopup = popup
                this.$bvModal.show('other-documents-preview-popup')
            }
        },
        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method
        async downloadFile(fileName,index) {
            let folder=''
            console.log('index here',index)
            if(Number.isInteger(index))
            {
                folder='customer-documents/'
            }
            let fileUrl = folder + fileName
            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                let fileExtension = response.headers['content-type']
                // if (
                //     fileExtension == 'image/png' ||
                //     fileExtension == 'image/jpg' ||
                //     fileExtension == 'image/jpeg'
                // ) {
                //     this.$bvModal.show('file-preview-popup')
                // } else {
                //     this.forceFileDownload(response, fileName)
                // }
                this.forceFileDownload(response, fileName)

            } catch (err) {
                console.log('Error occured: ', err)
            }
        }, // End of downloadFile() method
    }, // End of Component > mounted
} // End of export default
</script>
<style scoped>
.position-for-pending{
    position: inherit;
    margin: 0px;
}
</style>
